import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class ListModel<T> {
  items: T[]

  constructor(items: T[] = []) {
    this.items = items
  }
}
